export default (subFunnelName) => {
  return {
    'event': 'reg_to_corp_change',
    'funnel_name': 'AMR',
    'sub_funnel_name': subFunnelName,
  };
};